import {createFeature, createReducer, createSelector, on} from '@ngrx/store';
import {ISettingsState} from './settings-state.interface';
import {getApiActionReducers, STATUS} from '@binotel-frontend/bnt-common-components';
import {EPhoneUpdateSteps} from '@entities/settings';
import {SettingsActions} from './settings.actions';

const settingsFeatureKey = 'settingsFeature';

const initialState: ISettingsState = {
  currentPhoneUpdateStep: EPhoneUpdateSteps.Step1,
  phoneUpdate: null,
  phoneUpdateLoadingStatus: STATUS.default,
};

const settingsReducer = createReducer(
  initialState,
  ...getApiActionReducers<ISettingsState>()(
    SettingsActions.updateUsersPhone,
    'phoneUpdate'
  ),
  on(
    SettingsActions.setCurrentPhoneStep,
    (state, {to}): ISettingsState => ({
      ...state,
      currentPhoneUpdateStep: to,
    })
  )
);

export const settingsFeature = createFeature({
  name: settingsFeatureKey,
  reducer: settingsReducer,
  extraSelectors: ({selectPhoneUpdate}) => ({
    selectWaitingTime: createSelector(
      selectPhoneUpdate,
      (info) => info?.waitingTime
    ),
  }),
});
